import React, { Component } from 'react';
import { Container, Row } from 'react-grid-system';
import { connect } from 'react-redux';
import Banner from '../banner/banner';
import SubBanner from '../banner/sub-banner';
import Categories from '../categories/categories';
import DiscountedProducts from '../discountedProducts/discounted-products';
import Featured from '../featured-list/featured';
import LatestProducts from '../latest-products/latest-products';
import TopProductItem from '../top-product-item/top-product';
import TopProducts from '../top-products/top-products';
import './home.scss';

const mapStateToProps = (state: any) => {
  return {
    categories: state.categories.filter((c: any) => c.active),
    products: state?.products?.filter((p: any) => p.active && p.brandActive && p.categoryActive && p.warehouseCount > 0)
      .slice(0, 12).map((i: any) => <TopProductItem product={i}/>),
    productsOnSale: state?.products?.filter((p: any) => p.active && p.brandActive && p.categoryActive && p.warehouseCount > 0 && p.saleUntil && new Date(p.saleUntil) > new Date())
      .sort((a: any, b: any) => a.id < b.id)
      .slice(0, 12).map((i: any) => <TopProductItem product={i}/>),
    latestProducts: state?.products?.filter((p: any) => p.active && p.brandActive && p.categoryActive && p.warehouseCount > 0)
      .sort((a: any, b: any) => b.id - a.id)
      .slice(0, 12).map((i: any) => <TopProductItem product={i}/>),
  }
}

interface HomeProps {
  categories: any[],
  products: [],
  productsOnSale: [],
  latestProducts: [],
}

class Home extends Component<HomeProps> {

  componentDidMount() {
    window.scroll(0,0);
  }

  render() {
    return (
      <React.Fragment>
        <Banner></Banner>
        <SubBanner></SubBanner>
        <div className="home-page page">
          <Container fluid={true}>
            <Row>
              <Categories categories={this.props.categories}/>
            </Row>
            <Row>
              <DiscountedProducts
                title="Хямдралтай бараа бүтээгдэхүүнүүд"
                products={this.props.productsOnSale}
              />
             </Row>
            <Row>
              <LatestProducts title="Сүүлд нэмэгдсэн" products={this.props.latestProducts}/>
            </Row>
            <Row>
              <Featured/>
            </Row>
            <Row>
              <TopProducts title="Санал болгох бүтээгдэхүүн" products={this.props.products}/>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(Home)